import styled from 'styled-components';
import { FiChevronLeft } from 'react-icons/fi';
import { Subtitle2Text } from '@/utils/global-fonts';
import { Col, Row } from '@/components/grid/grid-component';

const Container = styled.div`
  display: block;
  position: relative;
  width: 90%;
  margin: 0 auto;
  padding-top: 32px;
`;
const ProductCategorySelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 25px;
  margin-top: 45px;
`;
const ProductCategoryImg = styled.img`
  object-fit: contain;
  width: 100%;
  max-height: 175px;
  margin-bottom: 10px;
`;

const ProductCategoryDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  color: ${({ theme }) => theme.COLOR_GREY3};
`;
const ProductCategoryTitle = styled(Subtitle2Text)`
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.2px;
  text-align: left;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  transition: all 0.2s ease-in-out;
`;

const ProductCategoryRow = styled(Row)`
  row-gap: 30px;
  margin-top: 32px;
`;

const ProductCategoryWrapper = styled(Col)`
  height: unset;
`;

const ProductCategory = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 32px;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid
    ${({ selected, theme }) =>
      selected ? theme.COLOR_PRIMARY : theme.COLOR_GREY2};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  transition: all 0.2s ease-in-out;
  @media (hover: hover) {
    &:hover {
      border: 1px solid ${({ theme }) => theme.COLOR_GREY1};
      .prodCatTitle {
        color: ${({ theme }) => theme.COLOR_BLACK} !important;
      }
    }
  }
`;

const ProductCategoryDescription = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  text-align: left;
  padding: 0px;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
`;

const BackActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`;

const BackIcon = styled(FiChevronLeft)`
  margin-right: ${({ mr }) => mr};
  font-size: ${({ fontSize }) => fontSize};
`;

const DescriptionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px;
  padding: 0px 0px;
`;
const DescriptionColKey = styled.div`
  padding: 0px;
  width: 60%;
`;
const DescriptionColValue = styled.div`
  text-align: right;
  padding: 0px;
`;
const BackButton = styled.div`
  cursor: pointer;
  font-weight: bold;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const StyledSelectProductCategory = {
  ProductCategory,
  Container,
  ProductCategorySelectionContainer,
  ProductCategoryImg,
  ProductCategoryTitle,
  ProductCategoryDescription,
  BackActionContainer,
  ProductCategoryDescriptionWrapper,
  BackIcon,
  DescriptionRow,
  DescriptionColKey,
  DescriptionColValue,
  LoaderContainer,
  BackButton,
  ProductCategoryRow,
  ProductCategoryWrapper,
};

export default StyledSelectProductCategory;
